<script>
export default {
  name: 'CpDisplaySocialMedia',
  components: {
    getEmbedUrl: require('../mixins/utils.js').default,
    socialMediaName: require('../mixins/utils.js').default,
  },
  props: {
    video: {
      type: String,
      required: true,
    },
  },
  computed: {
    videoEmbedUrl() {
      return this.getEmbedUrl(this.video);
    },
  },
};
</script>
<template>
  <iframe
    class="iframe-video"
    :class="{
      facebookReel: socialMediaName(video) === 'Facebook' && video.includes('reel/'),
      facebook: socialMediaName(video) === 'Facebook' && !video.includes('reel/'),
      tiktok: socialMediaName(video) === 'TikTok',
      instagram: socialMediaName(video) === 'Instagram',
    }"
    :src="videoEmbedUrl"
    allowfullscreen="allowfullscreen"
    frameborder="0"
  />
</template>

<style scoped>
.iframe-video {
  width: 100%;
  aspect-ratio: 16 / 9;
}

.facebook {
  width: 75%;
  height: 700px;
}

.tiktok {
  height: 756px;
}

.facebookReel {
  width: 75%;
  height: 1000px;
}

.instagram {
  width: 50%;
  aspect-ratio: 9 / 16;
}

@media screen and (max-width: 1400px) {
  .instagram {
    width: 60%;
  }
}

@media screen and (max-width: 1200px) {
  .facebookReel {
    height: 840px;
  }
  .instagram {
    width: 75%;
  }
}

@media screen and (max-width: 1024px) {
  .facebook {
    width: 100%;
  }
  .facebookReel {
    height: 730px;
  }
}

@media screen and (max-width: 900px) {
  .instagram {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .facebookReel {
    height: 785px;
  }
  .instagram {
    width: 75%;
  }
}

@media screen and (max-width: 600px) {
  .facebook {
    height: 600px;
  }
  .facebookReel {
    height: 650px;
    width: 100%;
  }
  .instagram {
    width: 100%;
  }
}

@media screen and (max-width: 550px) {
  .facebook {
    height: 500px;
  }
}
@media screen and (max-width: 450px) {
  .facebook {
    height: 400px;
  }
  .facebookReel {
    height: 500px;
  }
}

@media screen and (max-width: 375px) {
  .facebook {
    height: 300px;
  }
  .facebookReel {
    width: 100%;
    height: 540px;
  }
}
</style>
